import { render, staticRenderFns } from "./UserPersonalInformation.vue?vue&type=template&id=6878d778&scoped=true&"
import script from "./UserPersonalInformation.vue?vue&type=script&lang=js&"
export * from "./UserPersonalInformation.vue?vue&type=script&lang=js&"
import style0 from "./UserPersonalInformation.vue?vue&type=style&index=0&id=6878d778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6878d778",
  null
  
)

export default component.exports